import { SharedParams } from './shared-params.const';

const UserMangementService = '/user-management';
const AuthenticationsService = '/authentication';

// Controllers
const AuthenticationController = `${AuthenticationsService}/authentications`;
const GroupController = `${UserMangementService}/groups/`;
const LookupController = `${UserMangementService}/lookups/`;
const RoleController = `${UserMangementService}/roles/`;
const UserController = `${UserMangementService}/users/`;
const JobClassificationController = `${UserMangementService}/JobClassifications`;
const trainingCenterController = `${UserMangementService}/training-center/`;

export const TrainingCenter = {
  Controller: trainingCenterController,
  Dropdown: `${trainingCenterController}dropdown`,
  // Public projection of the centres flagged "show in home"; the paged list requires a token.
  Home: `${trainingCenterController}home`,
  HomeStatus: `${trainingCenterController}${SharedParams.HomeStatus}`,
  Profile: (trainingCenterId: number) =>  `${trainingCenterController}${trainingCenterId}/profile-details`,
}

export const UserManagement = {
  Authentication: {
    Controller: AuthenticationController,
    SsoLogout: `${AuthenticationController}/sso/logging-out`,
    SsoLogin: `${AuthenticationController}/sso/logging-in`,
    SsoAssertionConsumer: `${AuthenticationController}/sso/assertion-consumer`,
    TokenCodeValidation: (code: string) =>
      `${AuthenticationController}/${code}/token-code-validation`,
    PasswordForgetting: `${AuthenticationController}/password-forgetting`,
    PasswordResetting: `${AuthenticationController}/password-resetting`,
    PasswordChanging: `${AuthenticationController}/password-changing`,
    EmailIsExistValidation: (email: string) =>
      `${AuthenticationController}/${email}/user-email-existing-validation`,
    AdfsUserState: `${AuthenticationController}/adfs-user-state`,
  },
  Group: {
    GroupsController: GroupController,
    FreeGroupsForParents: `${GroupController}free-groups`,
    GroupMembers: (groupId: number) => `${GroupController}${groupId}/members`,
    GroupAvailableMembers: (groupId: number) =>
      `${GroupController}${groupId}/available-members`,
    AdminChanging: (groupId: number) =>
      `${GroupController}${groupId}/admin-changing`,
    AssignMemberToGroup: (groupId: number) =>
      `${GroupController}${groupId}/members`,
    DeclassifyMemberFromGroup: (groupId: number, memberId: number) =>
      `${GroupController}${groupId}/members/${memberId}`,
  },
  Lookup: {
    LookupsController: LookupController,
    // Countries:
    Countries: `${LookupController}countries`,
    Country: (countryId: Number) => `${LookupController}countries/${countryId}`,
    CountriesDropdown: `${LookupController}countries/${SharedParams.Dropdown}`,
    NationalitiesDropdown: `${LookupController}Nationalities/${SharedParams.Dropdown}`,
    QualificationsDropdown: `${LookupController}Qualifications/${SharedParams.Dropdown}`,

    CountriesExporting: `${LookupController}countries/${SharedParams.Exporting}`,
    // Regions
    Regions: `${LookupController}regions`,
    Region: (regionId: number) => `${LookupController}regions/${regionId}`,
    RegionsDropdownSignUp: (CountryId: number) => `${LookupController}regions/${SharedParams.Dropdown}/${CountryId}`,
    RegionsDropdown: `${LookupController}regions/${SharedParams.Dropdown}`,
    RegionsExporting: `${LookupController}regions/${SharedParams.Exporting}`,
    // Cities
    Cities: `${LookupController}cities`,
    City: (cityId: number) => `${LookupController}cities/${cityId}`,
    CitiesDropdownSignUp: (regionId: number) => `${LookupController}cities/${SharedParams.Dropdown}/${regionId}`,
    CitiesDropdown: `${LookupController}cities/${SharedParams.Dropdown}`,
    CitiesExporting: `${LookupController}cities/${SharedParams.Exporting}`
  },
  Role: {
    RolesController: RoleController,
    AllRoles: `${RoleController}all-roles`,
    SignupRoles: `${RoleController}signup-roles`,
    RoleUsers: (roleId: number) => `${RoleController}${roleId}/users`,
  },
  JobClassification: {
    Controller: `${JobClassificationController}`,
    GetJob: (jobId: number) => `${JobClassificationController}/get-job/${jobId}`,
  },
  User: {
    UsersController: UserController,
    Current: `${UserController}current`,
    UserRoles: (userId: number) => `${UserController}${userId}/roles`,
    UserStatus: `${UserController}{UserId}/${SharedParams.Status}`,
    UploadUserProfilePicture: (userId: number) =>
      `${UserController}${userId}/profile-picture`,
    UpdateProfilePicture:`${UserController}profile-picture`,
    FirebaseToken: `${UserController}firebase-token`,
    ExternalUserRegistration: `${UserController}external-user-registration`,
    WebexUsers: `${UserController}webex-users`,
    AdministratorsDropDown: `${UserController}administrators/${SharedParams.Dropdown}`,
    InstructorsDropDown: `${UserController}instructors/${SharedParams.Dropdown}`,
    InstructorsImport: `${UserController}instructors/${SharedParams.Importing}`,
    InstructorsExport: `${UserController}instructors/${SharedParams.Exporting}`,
    TraineesDropDown: `${UserController}trainees/${SharedParams.Dropdown}`,
    TraineesImport: `${UserController}trainees/${SharedParams.Importing}`,
    TraineesExport: `${UserController}trainees/${SharedParams.Exporting}`,
    TrainingCentersDropDown: `${UserController}training-centers/${SharedParams.Dropdown}`,
    // Public, personal-data-free projection used by the home page instructors carousel. The paged
    // /users directory is a full-PII list and requires the UserRead permission.
    HomeInstructors: `${UserController}home-instructors`,
    InstructorProfile: (userId: number) => `${UserController}${userId}/instructor-profile`,
    UserProfile : (userId: number) => `${UserController}${userId}/profile`,
    CheckActiveDirectoryUser: `${UserController}check-active-directory`,
    Job: {
      Controller: `${UserController}job`,
      JobDropDown: `${UserController}job/drop-down`,
      SkillsDropDown: `${UserController}job/skills-drop-down`,
      Details: (jobId: number) => `${UserController}job/details/${jobId}`,
    },
    newEmailVerification: `${UserController}new-email-token`,
    validateEmailToken: `${UserController}email-verification`,
  }
};
